export const environment = {
  production: true,
  showTestMessage: true,
  baseUrl: '/PnoChargerApi' 
};



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/environments/environment.ts